import { render } from "./index.vue?vue&type=template&id=7d79da3a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7d79da3a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d79da3a"],['__file',"src/components/BaseUi/DialogModal/src/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d79da3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d79da3a', __exports__)) {
    api.reload('7d79da3a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7d79da3a&scoped=true", () => {
    api.rerender('7d79da3a', render)
  })

}


export default __exports__